import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["inputTargetTable", "errorTable", "tab", "linkModal", "selectedDetailId", "cancelTable", "peraichiCancelTable"];
    static classes = ["hidden", "active"];
    static values = {travellerurl: String};

    connect() {
        console.log(this.peraichiCancelTableTarget);
        console.log(this.cancelTableTarget);
    }

    tabTargetConnected() {
        const hash = location.hash;
        if (hash) {
            const tabName = hash.slice(1);
            this.openContents(tabName);
            const li = document.getElementById(tabName + "Tab");
            this.activeTab(li);
        }
    }

    changeTab(event) {
        event.preventDefault();
        const el = event.currentTarget;
        const params = event.params;
        console.log(params);
        this.activeTab(el.parentElement);
        if (params.view != null && params.view != "") {
            this.openContents(params.view);
        }
    }

    activeTab(element) {
        const tabs = this.tabTarget.children;
        for (const t of tabs) {
            t.classList.remove(this.activeClass);
        }
        element.classList.add(this.activeClass);
        location.hash = element.id.slice(0, -3);
    }

    openContents(linkto) {
        switch (linkto) {
            case "inputTargetTable":
                this.inputTargetTableTarget.classList.remove(this.hiddenClass);
                this.errorTableTarget.classList.add(this.hiddenClass);
                this.cancelTableTarget.classList.add(this.hiddenClass);
                this.peraichiCancelTableTarget.classList.add(this.hiddenClass);
                break;
            case "errorTable":
                this.inputTargetTableTarget.classList.add(this.hiddenClass);
                this.errorTableTarget.classList.remove(this.hiddenClass);
                this.cancelTableTarget.classList.add(this.hiddenClass);
                this.peraichiCancelTableTarget.classList.add(this.hiddenClass);
                break;
            case "cancelTable":
                this.inputTargetTableTarget.classList.add(this.hiddenClass);
                this.errorTableTarget.classList.add(this.hiddenClass);
                this.cancelTableTarget.classList.remove(this.hiddenClass);
                this.peraichiCancelTableTarget.classList.add(this.hiddenClass);
                break;
            case "peraichiCancelTable":
                this.inputTargetTableTarget.classList.add(this.hiddenClass);
                this.errorTableTarget.classList.add(this.hiddenClass);
                this.cancelTableTarget.classList.add(this.hiddenClass);
                console.log(this.peraichiCancelTableTarget);
                this.peraichiCancelTableTarget.classList.remove(this.hiddenClass);
        }
    }

    // openLinkModal(event) {
    //   const button = event.currentTarget;
    //   this.selectedDetailIdTarget.value = button.dataset.id;
    //   this.linkModalTarget.classList.add('is-active')
    //
    // }
    //
    // closeLinkModal() {
    //   this.linkModalTarget.classList.remove('is-active')
    // }

}
